import React from 'react';
import { XMarkIcon } from '../../Icons';

interface BrochureEmailListProps {
  emails: string[];
  inputValue: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  onRemoveEmail: (index: number) => void;
}

export const BrochureEmailList: React.FC<BrochureEmailListProps> = ({
  emails,
  inputValue,
  onInputChange,
  onKeyDown,
  onBlur,
  onRemoveEmail,
}) => {
  return (
    <div>
      <label
        htmlFor="brochure-email"
        className="block text-xs font-black text-gray-500 uppercase tracking-widest mb-1"
      >
        Correos de destino
      </label>
      <div className="mt-1 flex flex-wrap items-center gap-2 p-3 border border-gray-200 rounded-xl shadow-inner bg-gray-50 focus-within:ring-2 focus-within:ring-sky-500 transition-all">
        {emails.map((email, index) => (
          <span
            key={index}
            className="flex items-center bg-sky-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm"
          >
            {email}
            <button
              type="button"
              onClick={() => onRemoveEmail(index)}
              className="ml-2 hover:text-red-200 transition-colors"
              aria-label={`Remover ${email}`}
            >
              <XMarkIcon className="w-3.5 h-3.5" />
            </button>
          </span>
        ))}
        <input
          type="email"
          id="brochure-email"
          value={inputValue}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          className="flex-grow p-0 border-none bg-transparent focus:ring-0 text-sm placeholder-gray-400"
          placeholder={emails.length === 0 ? 'ejemplo@correo.com' : 'Añadir otro...'}
        />
      </div>
      <p className="text-[10px] text-gray-400 mt-2 font-medium">
        Presiona Enter o Coma para añadir múltiples correos.
      </p>
    </div>
  );
};
